(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[401],{

/***/ 3369:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-intake/social-ai",
      function () {
        return __webpack_require__(1385);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7600:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var planConfigCA = {
    label: "Social AI",
    description: "Content created weekly and automatically posted to your socials.\nIncludes posting to Facebook and Instagram.",
    periods: [
        {
            id: "social-ai-local-monthly-cad",
            label: "Monthly",
            price: 9900,
            unit: "monthly",
            addons: [
                {
                    id: "platforms",
                    label: "Additional Platforms",
                    type: "multiselect",
                    options: [
                        {
                            id: "linkedin-*-cad",
                            itemPriceId: "linkedin-monthly-cad",
                            label: "LinkedIn",
                            price: 2900,
                            unit: "monthly"
                        }, 
                    ]
                },
                {
                    id: "setupAssistance",
                    label: "Setup Assistance",
                    description: "Don't have a Facebook or Instagram account yet? Let us set them up for you.",
                    type: "multiselect",
                    options: [
                        {
                            id: "facebook-setup-cad",
                            label: "Basic Facebook Page Creation",
                            price: 7500,
                            unit: "one-time"
                        },
                        {
                            id: "instagram-setup-cad",
                            label: "Basic Instagram Account Creation",
                            price: 7500,
                            unit: "one-time"
                        },
                        {
                            id: "linkedin-setup-cad",
                            label: "Basic LinkedIn Page Creation",
                            price: 7500,
                            unit: "one-time"
                        }, 
                    ]
                },
                {
                    id: "video",
                    label: "Video",
                    type: "multiselect",
                    options: [
                        {
                            id: "short-form-video-*-cad",
                            itemPriceId: "short-form-video-monthly-cad",
                            label: "Short-Form Videos",
                            price: 9900,
                            unit: "monthly"
                        }, 
                    ]
                }, 
            ]
        },
        {
            id: "social-ai-local-annual-cad",
            label: "Annual",
            price: 99000,
            unit: "annually",
            addons: [
                {
                    id: "platforms",
                    label: "Additional Platforms",
                    type: "multiselect",
                    options: [
                        {
                            id: "linkedin-*-cad",
                            itemPriceId: "linkedin-annual-cad",
                            label: "LinkedIn",
                            price: 29000,
                            unit: "annually"
                        }, 
                    ]
                },
                {
                    id: "setupAssistance",
                    label: "Setup Assistance",
                    description: "Don't have a Facebook or Instagram account yet? Let us set them up for you.",
                    type: "multiselect",
                    options: [
                        {
                            id: "facebook-setup-cad",
                            label: "Basic Facebook Page Creation",
                            price: 7500,
                            unit: "one-time"
                        },
                        {
                            id: "instagram-setup-cad",
                            label: "Basic Instagram Account Creation",
                            price: 7500,
                            unit: "one-time"
                        },
                        {
                            id: "linkedin-setup-cad",
                            label: "Basic LinkedIn Page Creation",
                            price: 7500,
                            unit: "one-time"
                        }, 
                    ]
                },
                {
                    id: "video",
                    label: "Video",
                    type: "multiselect",
                    options: [
                        {
                            id: "short-form-video-*-cad",
                            itemPriceId: "short-form-video-annual-cad",
                            label: "Short-Form Videos",
                            price: 99000,
                            unit: "annually"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};
/* harmony default export */ __webpack_exports__["Z"] = (planConfigCA);


/***/ }),

/***/ 6101:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var planConfigUS = {
    label: "Social AI",
    description: "Content created weekly and automatically posted to your socials.\nIncludes posting to Facebook and Instagram.",
    periods: [
        {
            id: "social-ai-local-monthly-usd",
            label: "Monthly",
            price: 9900,
            unit: "monthly",
            addons: [
                {
                    id: "platforms",
                    label: "Additional Platforms",
                    type: "multiselect",
                    options: [
                        {
                            id: "linkedin-*-usd",
                            itemPriceId: "linkedin-monthly-usd",
                            label: "LinkedIn",
                            price: 2900,
                            unit: "monthly"
                        }, 
                    ]
                },
                {
                    id: "setupAssistance",
                    label: "Setup Assistance",
                    description: "Don't have a Facebook or Instagram account yet? Let us set them up for you.",
                    type: "multiselect",
                    options: [
                        {
                            id: "facebook-setup-usd",
                            label: "Basic Facebook Page Creation",
                            price: 7500,
                            unit: "one-time"
                        },
                        {
                            id: "instagram-setup-usd",
                            label: "Basic Instagram Account Creation",
                            price: 7500,
                            unit: "one-time"
                        },
                        {
                            id: "linkedin-setup-usd",
                            label: "Basic LinkedIn Page Creation",
                            price: 7500,
                            unit: "one-time"
                        }, 
                    ]
                },
                {
                    id: "video",
                    label: "Short-Form Videos",
                    description: "20-120 second short-form videos for Reels. 4 per month.",
                    type: "multiselect",
                    options: [
                        {
                            id: "short-form-video-*-usd",
                            itemPriceId: "short-form-video-monthly-usd",
                            label: "Short-Form Videos",
                            price: 9900,
                            unit: "monthly"
                        }, 
                    ]
                }, 
            ]
        },
        {
            id: "social-ai-local-annual-usd",
            label: "Annual",
            price: 99000,
            unit: "annually",
            addons: [
                {
                    id: "platforms",
                    label: "Additional Platforms",
                    type: "multiselect",
                    options: [
                        {
                            id: "linkedin-*-usd",
                            itemPriceId: "linkedin-annual-usd",
                            label: "LinkedIn",
                            price: 29000,
                            unit: "annually"
                        }, 
                    ]
                },
                {
                    id: "setupAssistance",
                    label: "Setup Assistance",
                    description: "Don't have a Facebook or Instagram account yet? Let us set them up for you.",
                    type: "multiselect",
                    options: [
                        {
                            id: "facebook-setup-usd",
                            label: "Basic Facebook Page Creation",
                            price: 7500,
                            unit: "one-time"
                        },
                        {
                            id: "instagram-setup-usd",
                            label: "Basic Instagram Account Creation",
                            price: 7500,
                            unit: "one-time"
                        },
                        {
                            id: "linkedin-setup-usd",
                            label: "Basic LinkedIn Page Creation",
                            price: 7500,
                            unit: "one-time"
                        }, 
                    ]
                },
                {
                    id: "video",
                    label: "Short-Form Videos",
                    description: "20-120 second short-form videos for Reels.",
                    type: "multiselect",
                    options: [
                        {
                            id: "short-form-video-*-usd",
                            label: "4 per month",
                            itemPriceId: "short-form-video-annual-usd",
                            price: 99000,
                            unit: "annually"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};
/* harmony default export */ __webpack_exports__["Z"] = (planConfigUS);


/***/ }),

/***/ 6544:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var couponQueryHandler = function() {
    var url = new URL(window.location.href);
    var param = url.searchParams.get("coupon") || "";
    return param.split(",").filter(Boolean);
};
/* harmony default export */ __webpack_exports__["Z"] = (couponQueryHandler);


/***/ }),

/***/ 1385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ social_ai; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/PageContainer.tsx
var PageContainer = __webpack_require__(3340);
// EXTERNAL MODULE: ./components/Layout/PartnerHeader.tsx
var PartnerHeader = __webpack_require__(4271);
// EXTERNAL MODULE: ./components/Layout/Footer.tsx
var Footer = __webpack_require__(9677);
// EXTERNAL MODULE: ./containers/Intake/internal/IntakeViewModel.tsx + 57 modules
var IntakeViewModel = __webpack_require__(7754);
// EXTERNAL MODULE: ./containers/Intake/couponQueryHandler.ts
var couponQueryHandler = __webpack_require__(6544);
// EXTERNAL MODULE: ./containers/Intake/internal/socialAiQuestions.ts
var socialAiQuestions = __webpack_require__(8266);
// EXTERNAL MODULE: ./containers/Intake/internal/socialAiSteps.ts
var socialAiSteps = __webpack_require__(669);
// EXTERNAL MODULE: ./configs/social-ai/planConfigCA.ts
var planConfigCA = __webpack_require__(7600);
// EXTERNAL MODULE: ./configs/social-ai/planConfigUS.ts
var planConfigUS = __webpack_require__(6101);
;// CONCATENATED MODULE: ./configs/social-ai/config.ts





var config = {
    pageTitle: "Social AI Business Signup",
    partner: {
        code: "internal-intake-social-ai",
        name: "Social AI",
        franchiseCode: "",
        logo: "",
        repEmail: ""
    },
    countries: [
        "CA",
        "US"
    ],
    plan: {
        countries: {
            CA: planConfigCA/* default */.Z,
            US: planConfigUS/* default */.Z
        }
    },
    reps: [],
    questions: socialAiQuestions/* default */.Z,
    steps: socialAiSteps/* default */.Z,
    coupons: couponQueryHandler/* default */.Z
};
/* harmony default export */ var social_ai_config = (config);

;// CONCATENATED MODULE: ./pages/partner-intake/social-ai/index.tsx







var IntakeForm = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContainer/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntakeViewModel/* default */.Z, {
            config: social_ai_config
        })
    });
};
// @ts-ignore
IntakeForm.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHeader/* default */.Z, {
                name: social_ai_config.partner.name
            }),
            page,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var social_ai = (IntakeForm);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [86,9,774,888,179], function() { return __webpack_exec__(3369); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);